function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "486px",
    height: "500px",
    viewBox: "0 0 486 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial0",
    gradientUnits: "userSpaceOnUse",
    cx: -746.659973,
    cy: 781.440002,
    fx: -746.659973,
    fy: 781.440002,
    r: 13.89,
    gradientTransform: "matrix(-28.325952,-29.807629,-23.119165,21.979859,-2596.389893,-38900.308594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(21.568627%,58.431373%,22.352941%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "rgb(16.078431%,48.627451%,17.647059%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(8.235294%,33.72549%,10.980392%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial1",
    gradientUnits: "userSpaceOnUse",
    cx: -773.190002,
    cy: 771.25,
    fx: -773.190002,
    fy: 771.25,
    r: 13.89,
    gradientTransform: "matrix(-11.97612,-11.581371,-8.958526,9.268059,-2155.120117,-15858.879883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(2.745098%,23.137255%,6.27451%)",
      stopOpacity: 0.698039
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "rgb(3.137255%,29.019608%,7.45098%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 69.43,
    y1: 210.330002,
    x2: 260.839996,
    y2: 210.330002,
    gradientTransform: "matrix(1,0,0,-1,0,502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(32.156863%,81.960784%,48.627451%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(29.019608%,65.098039%,27.843137%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 194.399994,
    y1: 335.329987,
    x2: 194.399994,
    y2: 161.679993,
    gradientTransform: "matrix(1,0,0,-1,0,502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(16.078431%,52.156863%,18.431373%)",
      stopOpacity: 0.301961
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(29.019608%,65.098039%,27.843137%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 80.489998,
    y1: 297.220001,
    x2: 311.450012,
    y2: 497.540009,
    gradientTransform: "matrix(1,0,0,-1,0,502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(40%,81.568627%,32.156863%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(52.156863%,91.372549%,44.705882%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial2",
    gradientUnits: "userSpaceOnUse",
    cx: -824.109985,
    cy: 810.98999,
    fx: -824.109985,
    fy: 810.98999,
    r: 13.89,
    gradientTransform: "matrix(-9.02,-0.000000000000001105,-0.000000000000002338,19.09,-7120.399902,-15378.69043)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "rgb(30.588235%,70.588235%,23.137255%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(44.705882%,80%,38.039216%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 182.110001,
    y1: 377,
    x2: 69.43,
    y2: 377,
    gradientTransform: "matrix(1,0,0,-1,0,502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "rgb(75.294118%,87.843137%,45.882353%)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(81.960784%,92.156863%,58.431373%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial3",
    gradientUnits: "userSpaceOnUse",
    cx: -769.140015,
    cy: 808.900024,
    fx: -769.140015,
    fy: 808.900024,
    r: 13.89,
    gradientTransform: "matrix(-16.907703,-13.681816,13.641123,-16.863449,-23523.369141,3309.709961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "rgb(47.45098%,91.372549%,42.745098%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(81.568627%,92.156863%,46.27451%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial4",
    gradientUnits: "userSpaceOnUse",
    cx: -675.640015,
    cy: 793.280029,
    fx: -675.640015,
    fy: 793.280029,
    r: 13.89,
    gradientTransform: "matrix(15.991965,15.997547,45.541533,-45.54797,-25315.849609,47178.179688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(12.54902%,65.882353%,36.862745%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "rgb(3.529412%,26.666667%,16.470588%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial5",
    gradientUnits: "userSpaceOnUse",
    cx: -657.619995,
    cy: 853.98999,
    fx: -657.619995,
    fy: 853.98999,
    r: 13.89,
    gradientTransform: "matrix(0.000000000000000686,11.2,12.9,-0.00000000000000079,-10902.849609,7734.799805)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(20%,65.098039%,38.431373%)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "rgb(59.607843%,94.117647%,69.019608%)",
      stopOpacity: 0.301961
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial0)"
    },
    d: "M 69.429688 159.71875 C 69.429688 125.199219 97.410156 97.21875 131.921875 97.21875 L 486.011719 97.21875 L 486.011719 458.328125 C 486.011719 481.339844 467.359375 500 444.351562 500 L 152.738281 500 C 106.730469 500 69.429688 462.691406 69.429688 416.671875 Z M 69.429688 159.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial1)"
    },
    d: "M 69.429688 159.71875 C 69.429688 125.199219 97.410156 97.21875 131.921875 97.21875 L 486.011719 97.21875 L 486.011719 458.328125 C 486.011719 481.339844 467.359375 500 444.351562 500 L 152.738281 500 C 106.730469 500 69.429688 462.691406 69.429688 416.671875 Z M 69.429688 159.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 69.429688 229.171875 C 69.429688 194.648438 97.410156 166.671875 131.921875 166.671875 L 319.378906 166.671875 C 296.371094 166.671875 277.71875 185.328125 277.71875 208.339844 L 277.71875 291.671875 C 277.71875 314.679688 259.070312 333.339844 236.058594 333.339844 L 152.75 333.339844 C 106.738281 333.339844 69.441406 370.648438 69.441406 416.671875 L 69.441406 229.171875 Z M 69.429688 229.171875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 69.429688 229.171875 C 69.429688 194.648438 97.410156 166.671875 131.921875 166.671875 L 319.378906 166.671875 C 296.371094 166.671875 277.71875 185.328125 277.71875 208.339844 L 277.71875 291.671875 C 277.71875 314.679688 259.070312 333.339844 236.058594 333.339844 L 152.75 333.339844 C 106.738281 333.339844 69.441406 370.648438 69.441406 416.671875 L 69.441406 229.171875 Z M 69.429688 229.171875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 69.429688 83.328125 C 69.429688 37.308594 106.730469 0 152.738281 0 L 319.371094 0 L 319.371094 166.671875 L 152.738281 166.671875 C 106.730469 166.671875 69.429688 203.980469 69.429688 250 Z M 69.429688 83.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial2)"
    },
    d: "M 69.429688 83.328125 C 69.429688 37.308594 106.730469 0 152.738281 0 L 319.371094 0 L 319.371094 166.671875 L 152.738281 166.671875 C 106.730469 166.671875 69.429688 203.980469 69.429688 250 Z M 69.429688 83.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 69.429688 83.328125 C 69.429688 37.308594 106.730469 0 152.738281 0 L 319.371094 0 L 319.371094 166.671875 L 152.738281 166.671875 C 106.730469 166.671875 69.429688 203.980469 69.429688 250 Z M 69.429688 83.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial3)"
    },
    d: "M 319.371094 0 L 444.339844 0 C 467.347656 0 486 18.652344 486 41.660156 L 486 125.011719 C 486 148.019531 467.347656 166.671875 444.339844 166.671875 L 319.371094 166.671875 C 296.363281 166.671875 277.710938 148.019531 277.710938 125.011719 L 277.710938 41.660156 C 277.710938 18.652344 296.363281 0 319.371094 0 Z M 319.371094 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial4)"
    },
    d: "M 45.128906 236.109375 L 177.039062 236.109375 C 201.964844 236.109375 222.171875 256.316406 222.171875 281.238281 L 222.171875 413.199219 C 222.171875 438.125 201.964844 458.328125 177.039062 458.328125 L 45.128906 458.328125 C 20.207031 458.328125 0 438.125 0 413.199219 L 0 281.238281 C 0 256.316406 20.207031 236.109375 45.128906 236.109375 Z M 45.128906 236.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial5)"
    },
    d: "M 45.128906 236.109375 L 177.039062 236.109375 C 201.964844 236.109375 222.171875 256.316406 222.171875 281.238281 L 222.171875 413.199219 C 222.171875 438.125 201.964844 458.328125 177.039062 458.328125 L 45.128906 458.328125 C 20.207031 458.328125 0 438.125 0 413.199219 L 0 281.238281 C 0 256.316406 20.207031 236.109375 45.128906 236.109375 Z M 45.128906 236.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 169.480469 410.710938 L 135.230469 410.710938 L 113.730469 370.238281 C 112.960938 368.820312 112.371094 367.699219 111.960938 366.871094 C 111.609375 365.988281 111.21875 364.980469 110.808594 363.859375 L 110.460938 363.859375 C 109.929688 365.28125 109.429688 366.429688 108.960938 367.308594 C 108.488281 368.199219 107.929688 369.289062 107.28125 370.589844 L 84.980469 410.699219 L 52.679688 410.699219 L 91.441406 347.121094 L 55.339844 283.71875 L 89.140625 283.71875 L 108.25 319.851562 C 109.019531 321.328125 109.671875 322.628906 110.199219 323.75 C 110.789062 324.808594 111.378906 326.078125 111.96875 327.558594 L 112.320312 327.558594 C 113.140625 325.851562 113.789062 324.488281 114.269531 323.488281 C 114.800781 322.488281 115.511719 321.160156 116.390625 319.511719 L 136.210938 283.738281 L 168.421875 283.738281 L 131.789062 346.171875 L 169.488281 410.71875 Z M 169.480469 410.710938 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.0444c8576090b89785546026d30ac0d9.svg";
export { ForwardRef as ReactComponent };